// extracted by mini-css-extract-plugin
export var quillEditor = "_p6-1";
export var variable = "_p6-0";